import React from "react";

const highlights = [
  "Multi-tenant SaaS built for agencies and growing brands",
  "Role-based access for admins and staff",
  "CRM, billing, and e-commerce in one stack",
  "Designed for speed, clarity, and daily operations",
];

export default function VisionSection() {
  return (
    <section id="vision" className="saas-lp-section saas-lp-section--vision">
      <div className="saas-lp-inner saas-lp-vision">
        <div className="saas-lp-vision__copy">
          <p className="saas-lp-label">Our vision</p>
          <h2>One operating system for modern Indian businesses</h2>
          <p>
            Beentara was built for founders and operators who need more than a website or a
            spreadsheet — they need a connected platform that grows with them.
          </p>
          <p>
            From your first customer to a full team with roles and permissions, everything stays
            in sync: sales, billing, staff, and your online presence.
          </p>
        </div>

        <div className="saas-lp-vision__card">
          <ul>
            {highlights.map((line) => (
              <li key={line}>
                <span className="saas-lp-check" aria-hidden="true">✓</span>
                {line}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
